export interface OrganizationClient {
  id: string,
  name: string,
  clientType: ClientType
}

export enum ClientType {
  dataApi = 'DataApi',
}